import { FC, useState, useEffect } from 'react'
import { Box, useTheme } from '@mui/material'
import { EnterPassword } from './EnterPassword'
import { ResetConfrimation } from './ResetConfrimation'
import { SetPassword } from './SetPassword'
import ItemDetails from 'components/ItemDetails'
import { useTranslation } from 'react-i18next'
import { useAppState } from 'appContext'
import { useValidateMasterPassword, useMasterPasswordPublicKey } from 'hooks'
import { isNilOrEmpty } from 'packages/core'
import { encryptData } from 'utils/cryptoUtils'

export interface PasswordModalProps {
    open?: any
    setOpen?: any
    children?: any
    showDefaultContent?: boolean
}

export const PasswordModal: FC<PasswordModalProps> = (props) => {
    const { t } = useTranslation()
    const { open, setOpen, children, showDefaultContent = true } = props
    const [{ masterPassword }, dispatch]: any = useAppState()
    const [enteredPassword, setEnteredPassword] = useState('')
    const { isError, data: masterPasswordPublicKey } =
        useMasterPasswordPublicKey()
    const { data: validateMasterPassword, isLoading } =
        useValidateMasterPassword(enteredPassword)
    const [isInvalidPassword, setIsInvalidPassword] = useState(false)
    const theme = useTheme()

    useEffect(() => {
        if (validateMasterPassword) {
            if (validateMasterPassword.isValid) {
                setIsInvalidPassword(false)
                setOpen('addToCart')
                dispatch({
                    type: 'SET_MASTER_PASSWORD',
                    payload: enteredPassword,
                })
            } else {
                setIsInvalidPassword(true)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateMasterPassword])

    const handleClose = () => {
        setIsInvalidPassword(false)
        setOpen('')
    }
    const encryptAndSetEnteredPassword = (val: string) => {
        if (!isError) {
            setEnteredPassword(encryptData(val, masterPasswordPublicKey.value))
        }
    }
    const defaultContent = (
        <Box minWidth="130px" maxWidth="200px" margin="32px">
            <ItemDetails.ActionButton
                fontColor={theme?.palette?.common?.white}
                bgColor={theme?.palette?.primary?.main}
                width="fit-content"
                minWidth="100%"
                onClick={() =>
                    setOpen(masterPassword ? 'addToCart' : 'enterPassword')
                }
            >
                {t('Common_RequestAccess')}
            </ItemDetails.ActionButton>
        </Box>
    )
    return (
        <>
            {children ? children : showDefaultContent ? defaultContent : ''}
            {open === 'enterPassword' && (
                <EnterPassword
                    loading={isLoading}
                    error={isInvalidPassword}
                    open={open === 'enterPassword'}
                    onClose={handleClose}
                    onReset={() => setOpen('resetConfrimation')}
                    onCancel={handleClose}
                    onSucces={(val: string) => {
                        if (isNilOrEmpty(val)) {
                            setIsInvalidPassword(true)
                        } else {
                            setIsInvalidPassword(false)
                            encryptAndSetEnteredPassword(val)
                        }
                    }}
                />
            )}

            {open === 'resetConfrimation' && (
                <ResetConfrimation
                    open={open === 'resetConfrimation'}
                    onClose={() => setOpen('')}
                    onReset={() => setOpen('setPassword')}
                    onCancel={() => setOpen('enterPassword')}
                />
            )}

            {open === 'setPassword' && (
                <SetPassword
                    open={open === 'setPassword'}
                    onClose={() => setOpen('')}
                    onCancel={() => setOpen('enterPassword')}
                />
            )}
        </>
    )
}
